import { aboutItem } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">关于我们</h2>
        <p className="section-subtitle">了解香蕉文化漫画网的故事与使命</p>

        <div className="max-w-3xl mx-auto">
          {aboutItem.paragraphs.map((p, i) => (
            <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              {p}
            </p>
          ))}

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            {aboutItem.stats.map((s) => (
              <div
                key={s.label}
                className="text-center p-4 bg-background-50 rounded-xl border border-background-200"
              >
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600 mb-1">
                  {s.value}
                </p>
                <p className="text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}